export const NAVIGATION_BAR_HEIGHT = 80;
